import React, { useState } from "react";
import { addAwardsAccolades } from "../../Adapters/ApiAdapter";
import {
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";

const AddAwardsAccolades = ({ onAddSuccess }) => {
  const [formData, setFormData] = useState({
    heading: "",
    sub_heading: "",
  });
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  // Handle text input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle file input change
  const handleFileChange = (e) => {
    setImage(e.target.files[0]);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const requestData = new FormData();
    requestData.append("heading", formData.heading);
    requestData.append("sub_heading", formData.sub_heading);
    if (image) {
      requestData.append("Img_path", image);
    }

    setLoading(true);

    try {
      const response = await addAwardsAccolades(requestData);
      toast.dismiss(); // Clear any existing toast messages

      if (response && response.status === "true") {
        // Ensure response contains a message
        toast.success(response.message, { autoClose: 3000 });

        // **Reset form fields & image after success**
        setFormData({
          heading: "",
          sub_heading: "",
        });
        setImage(null);

        // Refresh the list or close the form after success
        setTimeout(() => {
          if (onAddSuccess) onAddSuccess();
        }, 2000);
      } else {
        toast.error("Failed to add award. Please try again.");
      }
    } catch (error) {
      console.error("Error adding award:", error);
      toast.error("Failed to add award. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} p={3}>
      <Helmet>
        <title>Add Awards and Accolades</title>
        <meta name="description" content="Add Awards and Accolades" />
      </Helmet>
      <ToastContainer />
      <Typography variant="h5" gutterBottom>
        Add Awards and Accolades
      </Typography>

      <TextField
        fullWidth
        margin="normal"
        label="Heading"
        name="heading"
        value={formData.heading}
        onChange={handleChange}
        required
      />

      <TextField
        fullWidth
        margin="normal"
        label="Sub Heading"
        name="sub_heading"
        value={formData.sub_heading}
        onChange={handleChange}
        required
      />

      <Button
        variant="contained"
        component="label"
        style={{ marginTop: "16px", marginBottom: "16px" }}
      >
        Upload Image
        <input
          type="file"
          accept="image/*"
          hidden
          onChange={handleFileChange}
        />
      </Button>
      {image && <Typography>{image.name}</Typography>}

      <br />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={loading}
        style={{ marginTop: "16px" }}
      >
        {loading ? <CircularProgress size={24} /> : "Submit"}
      </Button>
    </Box>
  );
};

export default AddAwardsAccolades;
